import { useEffect, useState } from 'react';
import { ROUTES, SectionId } from '@/shared/routes';

const useActiveSectionId = (enabled: boolean): SectionId => {
  const [activeId, setActiveId] = useState<SectionId>('home');

  useEffect(() => {
    if (!enabled) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id as SectionId);
          }
        }
      },
      { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
    );

    for (const { id } of ROUTES) {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    }

    return () => observer.disconnect();
  }, [enabled]);

  return activeId;
};

export default useActiveSectionId;
